export default "__VITE_ASSET__906c56e4__"